export default __webpack_public_path__ + "static/media/WhatsappRound.1dca8eee.svg";